
export const moduleName = `fbtSummary`
